import React from "react";
const CurlyHairActive = () => {
  return (
    <div className="blogWhat-content">
      <h5>6. How Active Is Your Lifestyle?</h5>
      <p>
        Curly hair requires a bit more attention, especially if you live an
        active lifestyle. Regular workouts, time outdoors, or daily exposure to
        humidity can impact how well curls hold up. If you’re frequently on the
        go, consider if you have the time for refreshing and maintaining your
        curls regularly. Lightweight products and moisture-locking methods can
        help, but knowing the added care needed can help you make an informed
        decision.
      </p>
      <br />
    </div>
  );
};

export default CurlyHairActive;
